import { Button } from '@/components/ui/button.js';
import { Column } from '@tanstack/react-table';
import { ArrowUpDown, SortAsc, SortDesc } from 'lucide-react';

export function TableHeaderSorting<Data = unknown>({ column }: { column: Column<Data> }) {
  if (!column.getCanSort()) {
    return null;
  }

  return (
    <div>
      <Button
        variant="ghost"
        size="sm"
        className="px-2 h-8 data-[state=open]:bg-accent flex items-center"
        onClick={() => {
          column.toggleSorting(column.getIsSorted() !== 'desc');
        }}
      >
        {column.getIsSorted() === 'desc' ? (
          <SortDesc className="h-4 w-4" />
        ) : column.getIsSorted() === 'asc' ? (
          <SortAsc className="h-4 w-4" />
        ) : (
          <ArrowUpDown className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
